import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  table: {
    width: '100%',
    '.ant-table-footer': {
      background: 'white',
      border: 'none !important'
    }
  },
  producerText: {
    maxWidth: '400px !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}))
